<template>
  <section
    v-if="!isLoadingBooks()"
    class="book-section book-lists-section--highlights"
    name="books"
    tag="div"
  >
    <div class="container">
      <div class="book-list">
        <HighlightsCard
          v-for="book in books"
          :key="book.id"
          :book="book"
          @unitClick="openBook(book)"
        />
      </div>
    </div>
    <HighlightsEmpty v-if="books.length === 0" />
  </section>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useWait } from '@/app/composables/useWait'

import HighlightsCard from '@/app/components/doc/highlights/HighlightsCard.vue'
import HighlightsEmpty from '@/app/components/book/highlights/HighlightsEmpty.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import { HighlightsAllDoc } from '@/models/interfaces'

const router = useRouter()
const wait = useWait()

const books = ref<HighlightsAllDoc[]>([])

onBeforeMount(async () => {
  refreshHighlights()
})

async function refreshHighlights(): Promise<void> {
  wait.end('Error Loading Books')
  wait.start('Loading Books')
  try {
    const response = await backend.getHighlightsGrouped()
    books.value = response
  } catch (error: any) {
    wait.start('Error Loading Books')
    Sentry.captureException(error)
  } finally {
    wait.end('Loading Books')
  }
}

function openBook(book: HighlightsAllDoc): void {
  router.push({
    // Note: this works only for books, if we want to show
    // Highlights for other types of content, we need to fix this.
    // https://github.com/shortformhq/main/issues/11389
    name: 'book.highlights',
    params: {
      url_slug: book.url_slug,
    },
  })
}

function isLoadingBooks(): boolean {
  return wait.is('Loading Books')
}
</script>
